module.exports = __webpack_public_path__ + "static/ube-bar-d189363c219063f0ed98881ca8871c6d.jpg";